import { render, staticRenderFns } from "./DashboardDeptInfo.vue?vue&type=template&id=2cac3c2c&scoped=true"
import script from "./DashboardDeptInfo.vue?vue&type=script&lang=js"
export * from "./DashboardDeptInfo.vue?vue&type=script&lang=js"
import style0 from "./DashboardDeptInfo.vue?vue&type=style&index=0&id=2cac3c2c&prod&scoped=true&lang=css"
import style1 from "./DashboardDeptInfo.vue?vue&type=style&index=1&id=2cac3c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cac3c2c",
  null
  
)

export default component.exports